import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Info",
  "use": "Info-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Info\"><path d=\"M512 170.667a341.333 341.333 0 1 1 0 682.666 341.333 341.333 0 0 1 0-682.666zM512 512l-4.95.299a42.837 42.837 0 0 0-37.717 42.368V640c0 23.467 19.2 42.667 42.667 42.667l4.95-.299c21.162-2.475 37.717-20.565 37.717-42.368v-85.333C554.667 531.2 535.467 512 512 512zm0-170.667a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol